import { DefaultTheme } from "styled-components";

import { TColorScheme } from "../colors.types";

export const getDarkStyledTheme = (colors: TColorScheme): DefaultTheme => {
  return {
    features: {
      firstBillingModal: {
        bgColor: `linear-gradient(0deg, ${colors.neutral[1200]} 50%, ${colors.neutral[1100]} 50%)`,
      },
      dashboard: {
        branchsInformation: {
          bgColor: colors.neutral[1100],
        },
        installationListMap: {
          subtitleColor: colors.neutral[500],
          skeletonBgColor: colors.neutral[1100],
          popupBgColor: colors.neutral[1100],
          linkButton: {
            bgColor:
              "linear-gradient(39.68deg, #434E56 0%, rgba(53, 62, 70, 0.75) 92.27%)",
            iconColor: colors.neutral[600],
            hoverIconColor: colors.white,
          },
        },
        missedAdvantage: {
          borderColor: colors.neutral[900],
          titleColor: colors.white,
          descriptionColor: colors.neutral[500],
          changeTariffButton: {
            bgColor: colors.neutral[1000],
            color: colors.white,
            selectedBgColor: colors.primary[100],
            selectedColor: colors.neutral[1100],
          },
        },
        notBillingFoundCard: {
          hoverBgColor: "rgba(165, 100, 247, 30%)",
          hoverColor: colors.secondary[600],
          buttonBgColor: colors.secondary[600],
          buttonHoverColor: colors.secondary[500],
        },
        fineCard: {
          borderColor: colors.neutral[900],
          error: {
            numberColor: colors.error[400],
            titleColor: colors.error[400],
            badgeBgColor: colors.neutral[1000],
            badgeNumberColor: colors.error[400],
            badgeNameColor: colors.error[300],
            badgeIconColor: colors.error[500],
            badgeBorderColor: colors.error[300],
          },
          gray: {
            numberColor: colors.neutral[700],
            titleColor: colors.neutral[500],
            badgeBgColor: colors.neutral[100],
            badgeNumberColor: colors.neutral[700],
            badgeNameColor: colors.neutral[600],
            badgeIconColor: colors.neutral[700],
            badgeBorderColor: colors.neutral[300],
          },
        },
        summaryGraph: {
          titleColor: colors.white,
          barColors: [colors.secondary[500], colors.primary[200]],
          barBgColor: colors.neutral[1100],
        },
        summaryCard: {
          footerColor: colors.neutral[700],
          footerBgColor: colors.neutral[1000],
          footerNumberColor: colors.neutral[500],
          footerBorderColor: colors.neutral[900],
          primary: {
            titleColor: colors.primary[700],
            numberColor: colors.neutral[100],
            decimalColor: colors.neutral[400],
            unitColor: colors.neutral[300],
            subtitleColor: colors.white,
            iconColor: colors.primary[300],
            iconBorderColor: colors.primary[300],
            iconBgColor: colors.primary[900],
            progressColor: colors.primary[200],
            progressStrokeColor: colors.primary[400],
            progressDangerColor: colors.primary[400],
            progressStrokeDangerColor: colors.primary[400],
            footerNumberColor: colors.primary[300],
            footerBadgeColor: colors.neutral[1100],
            footerBadgeBgColor: colors.primary[400],
            switchBgColor: colors.primary[400],
            switchColor: colors.neutral[1100],
            switchHandleColor: colors.neutral[1100],
          },
          secondary: {
            titleColor: colors.secondary[700],
            numberColor: colors.neutral[100],
            decimalColor: colors.neutral[400],
            unitColor: colors.neutral[300],
            subtitleColor: colors.white,
            iconColor: colors.secondary[300],
            iconBorderColor: colors.secondary[300],
            iconBgColor: colors.secondary[900],
            progressColor: colors.secondary[200],
            progressStrokeColor: colors.secondary[400],
            progressDangerColor: colors.secondary[400],
            progressStrokeDangerColor: colors.secondary[400],
            footerNumberColor: colors.secondary[300],
            footerBadgeColor: colors.neutral[1100],
            footerBadgeBgColor: colors.secondary[400],
            switchBgColor: colors.secondary[400],
            switchColor: colors.neutral[1100],
            switchHandleColor: colors.neutral[1100],
          },
          gray: {
            titleColor: colors.neutral[700],
            numberColor: colors.neutral[600],
            decimalColor: colors.neutral[400],
            unitColor: colors.neutral[500],
            subtitleColor: colors.neutral[600],
            iconColor: colors.neutral[500],
            iconBorderColor: colors.neutral[300],
            iconBgColor: colors.neutral[200],
            progressColor: colors.neutral[200],
            progressStrokeColor: colors.neutral[200],
            progressDangerColor: colors.neutral[200],
            progressStrokeDangerColor: colors.neutral[200],
            footerNumberColor: colors.neutral[700],
            footerBadgeColor: colors.neutral[700],
            footerBadgeBgColor: colors.neutral[1100],
            switchBgColor: colors.neutral[400],
            switchColor: colors.neutral[1100],
            switchHandleColor: colors.neutral[1100],
          },
        },
      },
      alarms: {
        tableExpandIconColor: colors.neutral[700],
        tableExpandIconDotColor: colors.primary[100],
        customErrorColor: colors.error[500],
        dividerColor: colors.neutral[900],
        alarmSwitch: {
          critical: {
            iconColor: colors.error[300],
            lineColor: colors.error[500],
          },
          warning: {
            iconColor: colors.warning[300],
            lineColor: colors.warning[500],
          },
          info: {
            iconColor: colors.info[300],
            lineColor: colors.info[500],
          },
        },
        userTag: {
          email: {
            color: colors.primary[500],
          },
          sms: {
            color: colors.secondary[500],
          },
        },
      },
      billings: {
        billingTotalCard: {
          titleColor: colors.neutral[500],
          dividerColor: colors.neutral[900],
          tariffButtonBgColor: colors.error[500],
          tariffButtonColor: colors.neutral[1100],
          neutral: {
            numberColor: colors.neutral[200],
            decimalColor: colors.neutral[600],
            unitColor: colors.neutral[100],
          },
          success: {
            numberColor: colors.primary[400],
            decimalColor: colors.primary[400],
            unitColor: colors.primary[400],
          },
          error: {
            numberColor: colors.error[400],
            decimalColor: colors.error[400],
            unitColor: colors.error[400],
          },
        },
        billingTabs: {
          billingGraphColors: [
            colors.primary[400],
            colors.secondary[500],
            colors.primary[100],
          ],
          billingDetailGraphColors: [
            colors.primary[500],
            colors.secondary[500],
            colors.secondary[700],
            colors.neutral[300],
            colors.neutral[500],
            colors.neutral[700],
            colors.neutral[900],
            colors.secondary[900],
            colors.primary[700],
          ],
          billingUnitPriceGraphColors: [
            colors.primary[500], colors.secondary[500],
          ],
        },
        billingDetails: {
          header: {
            dateInfoBox: {
              bgColor: colors.neutral[900],
              innerBoxBgColor: colors.neutral[1100],
              color: colors.neutral[1000],
            },
            chevronIconColor: colors.neutral[200],
          },
          pieChart: {
            borderColor: colors.neutral[1100],
            color: colors.neutral[200],
            chartColors: [
              colors.primary[500],
              colors.primary[400],
              colors.secondary[900],
              colors.secondary[400],
              colors.neutral[500],
              colors.neutral[300],
              colors.neutral[900],
              colors.neutral[700],
            ],
          },
          differenceCard: {
            bgColor: colors.neutral[1200],
            color: colors.neutral[400],
          },
          infoBox: {
            bgColor: colors.primary[100],
            color: colors.primary[600],
          },
          whatCanIDoStepper: {
            header: {
              bgColor: colors.neutral[1200],
              titleColor: colors.neutral[300],
              color: colors.neutral[600],
              linkColor: colors.primary[500],
            },
            step: {
              titleColor: colors.neutral[800],
              color: colors.neutral[1000],
            },
          },
        },
        layoutButtons: {
          borderColor: colors.neutral[300],
          iconColor: colors.neutral[300],
        },
      },
      tariffs: {
        bgColor: colors.neutral[1100],
        weakColor: colors.neutral[700],
        color: colors.neutral[200],
        dividerColor: colors.neutral[900],
        amountText: {
          color: colors.white,
          bgColor: colors.neutral[1100],
          borderColor: colors.neutral[800],
        },
        advantageBadge: {
          color: colors.secondary[600],
          bgColor: colors.secondary[100],
          emphasisBgColor: colors.secondary[200],
        },
        carouselButton: {
          bgColor: colors.neutral[1100],
          borderColor: colors.neutral[900],
          iconColor: colors.neutral[400],
        },
        advantageous: {
          bgColor: colors.secondary[400],
          color: colors.neutral[1100],
          borderColor: colors.secondary[400],
        },
        current: {
          bgColor: colors.neutral[200],
          color: colors.neutral[1100],
          borderColor: colors.neutral[700],
        },
        currentAndAdvantageous: {
          bgColor: colors.primary[200],
          color: colors.neutral[1100],
          borderColor: colors.primary[100],
        },
        default: {
          bgColor: colors.neutral[900],
          color: colors.white,
          borderColor: colors.neutral[900],
        },
      },
      billingPrediction: {
        chart: {
          seriesColors: [colors.primary[200], colors.secondary[400]],
          areaColor: colors.secondary[400],
        },
        switch: {
          titleColor: colors.neutral[600],
        },
        informationBoxShadowColor: colors.neutral[1200],
      },
      mcpPrediction: {
        card: {
          titleColor: colors.neutral[500],
          descriptionColor: colors.neutral[700],
          integerColor: colors.white,
          fractionColor: colors.neutral[700],
          unitColor: colors.white,
          buttonBgColor: colors.neutral[900],
          buttonBorderHoverColor: colors.neutral[1100],
          buttonIconColor: colors.neutral[400],
          subTextColor: colors.neutral[600],
        },
        lineChartColors: [colors.primary[500], colors.secondary[500]],
        heatMapColors: [
          colors.success[600],
          colors.success[300],
          colors.success[200],
          colors.warning[400],
          colors.error[300],
          colors.error[400],
          colors.error[600],
        ],
        itemBorderColor: colors.neutral[1200],
      },
      sustainability: {
        switch: {
          titleColor: colors.neutral[600],
        },
        comparisonChartColors: [colors.primary[400], colors.secondary[500]],
      },
      budgetPlanning: {
        lineChartColors: [colors.primary[400], colors.secondary[400]],
        barChartColors: [
          colors.primary[400],
          colors.secondary[500],
          colors.neutral[100],
        ],
        budgetForm: {
          formDividerBorderColor: colors.neutral[900],
          formBgColor: colors.neutral[1100],
          formTotalBoxBorderColor: colors.neutral[700],
        },
      },
      administration: {
        modalForm: {
          secondaryButton: {
            bgColor: colors.secondary[200],
            color: colors.secondary[600],
            hoverColor: colors.secondary[500],
            hoverBorderColor: colors.secondary[600],
          },
          sectionTitle: {
            color: colors.primary[200],
            borderColor: colors.primary[200],
          },
          dividerColor: colors.neutral[900],
          sideTitleColor: colors.neutral[600],
          addonColor: colors.neutral[700],
        },
      },
      ososDetail: {
        lineChartColors: [colors.neutral[100], colors.primary[500]],
        marklineColor: {
          success: colors.success[700],
          warning: colors.warning[400],
          error: colors.error[600],
        },
        gaugeChart: {
          detail: {
            color: colors.neutral[200],
            lightColor: colors.neutral[400],
          },
          success: {
            color: colors.primary[500],
            progressColor: colors.primary[500],
          },
          warning: {
            color: colors.orange[500],
            progressColor: colors.orange[500],
          },
          error: {
            color: colors.error[500],
            progressColor: colors.error[500],
          },
        },
      },
      sensorCompare: {
        filterForm: {
          headerColor: colors.neutral[200],
          headerBorderColor: colors.neutral[800],
        },
      },
      sensorDetail: {
        switchableChartColors: [
          colors.neutral[300],
          colors.primary[300],
          colors.secondary[300],
          colors.error[300],
          colors.neutral[600],
          colors.primary[600],
          colors.secondary[600],
          colors.error[600],
        ],
      },
      ososOnboarding: {
        multiStepForm: {
          stepNumberColor: colors.neutral[400],
          titleColor: colors.primary[500],
          infoBoxBgColor: colors.primary[100],
          infoBoxBorderColor: colors.primary[500],
          infoBoxColor: colors.primary[500],
          infoColor: colors.neutral[600],
          infoDarkColor: colors.neutral[1000],
          emphasisColor: colors.primary[500],
          ososInfoButton: {
            primary: {
              bgColor: colors.primary[100],
              color: colors.primary[500],
              bgHoverColor: colors.primary[200],
            },
            secondary: {
              bgColor: colors.secondary[100],
              color: colors.secondary[500],
              bgHoverColor: colors.secondary[200],
            },
          },
        },
        ososInfo: {
          titleColor: colors.neutral[1100],
          infoColor: colors.neutral[600],
          infoDarkColor: colors.neutral[1000],
          emphasisColor: colors.primary[500],
          cardBgColor: colors.white,
          infoBoxBgColor: colors.primary[100],
          infoBoxColor: colors.primary[500],
          infoBoxBorderColor: colors.primary[500],
          badgeColor: colors.neutral[600],
          badgeBorderColor: colors.neutral[600],
          toggleButtonColor: colors.primary[500],
          toggleButtonBorderColor: colors.primary[500],
        },
        formResult: {
          titleColor: colors.primary[500],
          color: colors.neutral[900],
          spinnerColor: colors.primary[400],
        },
      },
      generation: {
        weatherCard: {
          weakTextColor: colors.neutral[500],
          unitColor: colors.neutral[500],
        },
      },
    },
    components: {
      tableBadge: {
        primary: {
          borderColor: colors.primary[300],
          color: colors.primary[500],
          bgColor: colors.primary[100],
        },
        secondary: {
          borderColor: colors.secondary[300],
          color: colors.secondary[500],
          bgColor: colors.secondary[100],
        },
        neutral: {
          borderColor: colors.neutral[800],
          color: colors.neutral[600],
          bgColor: colors.neutral[1000],
        },
        warning: {
          borderColor: colors.warning[500],
          color: colors.warning[600],
          bgColor: colors.warning[100],
        },
        info: {
          borderColor: colors.info[300],
          color: colors.info[600],
          bgColor: colors.info[100],
        },
        critical: {
          borderColor: colors.error[300],
          color: colors.error[600],
          bgColor: colors.error[100],
        },
      },
      customBadge: {
        warning: {
          bgColor: colors.warning[200],
          color: colors.warning[500],
        },
        error: {
          bgColor: colors.error[200],
          color: colors.error[500],
        },
        success: {
          bgColor: colors.primary[200],
          color: colors.primary[500],
        },
      },

      stepper: {
        activeBgColor: colors.primary[500],
        inactiveBgColor: colors.neutral[200],
        activeLineColor: colors.primary[500],
        inactiveLineColor: colors.neutral[300],
        activeIconColor: colors.white,
        inactiveIconColor: colors.neutral[600],
        activeColor: colors.white,
        inactiveColor: colors.neutral[600],
      },
      table: {
        cellBorderColor: colors.neutral[900],
        actionCellBgColor: colors.neutral[1100],
        tableBorderColor: colors.neutral[900],
      },
      card: {
        tabBottomBorderColor: colors.neutral[900],
      },
      tableColumnSearchInput: {
        bgColor: colors.neutral[1100],
      },
      tableColumnsFilter: {
        hoverBgColor: colors.neutral[1000],
        borderColor: colors.neutral[1000],
        dividerColor: colors.neutral[900],
        infoTextColor: colors.neutral[500],
      },
      tabButtons: {
        bgColor: colors.neutral[1000],
        buttonColor: colors.neutral[400],
        activeButtonBgColor: colors.neutral[1100],
        activeButtonColor: colors.white,
      },
      modal: {
        borderColor: colors.neutral[900],
        borderDarkColor: colors.neutral[600],
      },
      useScreenshot: {
        bgColor: colors.neutral[1100],
      },
      samplingCard: {
        titleColor: colors.neutral[700],
        descriptionColor: colors.neutral[500],
        integerColor: colors.white,
        fractionColor: colors.neutral[700],
        unitColor: colors.white,
        buttonBgColor: colors.neutral[900],
        buttonBorderHoverColor: colors.neutral[1100],
        buttonIconColor: colors.neutral[400],
      },
      chartCard: {
        fullscreenBgColor: colors.neutral[1200],
      },
      collapserButton: {
        bgColor: colors.neutral[1200],
        handlerBgColor: colors.neutral[700],
        handlerHoverColor: colors.neutral[800],
      },
      carbonFootprintCard: {
        primary: {
          bgColor: colors.primary[100],
          iconColor: colors.primary[300],
          valueColor: colors.primary[600],
          subtitleColor: colors.primary[400],
          selectBgColor: colors.primary[200],
          selectHoverBgColor: colors.primary[300],
          selectColor: colors.primary[700],
        },
        info: {
          bgColor: colors.info[100],
          iconColor: colors.info[300],
          valueColor: colors.info[600],
          subtitleColor: colors.info[400],
          selectBgColor: colors.info[200],
          selectHoverBgColor: colors.info[300],
          selectColor: colors.info[700],
        },
        error: {
          bgColor: colors.error[100],
          iconColor: colors.error[300],
          valueColor: colors.error[600],
          subtitleColor: colors.error[400],
          selectBgColor: colors.error[200],
          selectHoverBgColor: colors.error[300],
          selectColor: colors.error[700],
        },
      },
      secondaryButton: {
        bgColor: colors.secondary[500],
        color: colors.white,
        hoverColor: colors.white,
        hoverBgColor: colors.secondary[600],
      },
      generationInfoCard: {
        default: {
          bgColor: colors.neutral[1100],
          borderColor: colors.neutral[900],
          titleColor: colors.neutral[500],
          numberColor: colors.white,
          unitColor: colors.neutral[700],
        },
        highlighted: {
          bgColor: colors.neutral[1100],
          borderColor: colors.primary[200],
          titleColor: colors.primary[200],
          numberColor: colors.primary[200],
          unitColor: colors.primary[100],
        },
      },
      mapMarkers: {
        clusterPolygonBgColor: colors.white,
        clusterPolygonBorderColor: colors.neutral[800],
      },
    },
    layouts: {
      authenticationLayout: {
        color: colors.primary[900],
      },
      mainLayout: {
        header: {
          accountButton: {
            bgColor: colors.neutral[1100],
            buttonColor: colors.primary[100],
            buttonBorderColor: colors.neutral[900],
            boxBgColor: colors.neutral[1200],
            boxBorderColor: colors.neutral[800],
            boxButtonBgColor: colors.neutral[1100],
            boxButtonBorderColor: colors.neutral[500],
            companyTextColor: colors.neutral[100],
            nameTextColor: colors.neutral[400],
            statusTextColor: colors.neutral[600],
          },
          toolButton: {
            bgColor: "transparent",
            hoverBgColor: colors.neutral[1100],
            iconColor: colors.white,
            hoverIconColor: colors.neutral[100],
          },
          notifications: {
            contentColor: colors.neutral[100],
            timeColor: colors.neutral[800],
            groupTitleColor: colors.neutral[600],
            dividerColor: colors.neutral[900],
            criticalIconColor: colors.error[400],
            infoIconColor: colors.info[400],
            warningIconColor: colors.warning[400],
            numberBadgeBgColor: colors.error[400],
          },
        },
        sidebar: {
          versionText: {
            bgColor: colors.neutral[1100],
            startColor: colors.primary[200],
            endColor: colors.secondary[500],
          },
          menu: {
            bgColor: "transparent",
          },
          menuItem: {
            hoverBgColor: colors.neutral[1000],
            titleColor: colors.neutral[700],
            selectedItemBgColor: colors.primary[100],
            selectedItemColor: colors.neutral[1100],
            submenuIconColor: colors.neutral[700],
          },
        },
        triggerButton: {
          iconColor: colors.neutral[700],
          iconHoverColor: colors.primary[100],
          bgHoverColor: colors.neutral[900],
        },
      },
    },
  };
};
